import React from "react";
import { observer } from "mobx-react";
import { BotErrorViewStore } from "../../store";
import { BotErrorViewForm } from "./BotErrorViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type BotErrorViewProps = {
  botErrorViewStore: BotErrorViewStore;
};

export const BotErrorView: React.FC<BotErrorViewProps> = observer(
  ({ botErrorViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <BotErrorViewForm
          errorType={botErrorViewStore.errorTypeValue}
          severity={botErrorViewStore.severityValue}
          message={botErrorViewStore.messageValue}
          stackTrace={botErrorViewStore.stackTraceValue}
          context={botErrorViewStore.contextValue}
          recoverable={botErrorViewStore.recoverableValue}
          requiresHumanIntervention={
            botErrorViewStore.requiresHumanInterventionValue
          }
          screenshotFiles={botErrorViewStore.screenshotFiles}
          domSnapshotFiles={botErrorViewStore.domSnapshotFiles}
          onPrint={(handlePrint: () => void) =>
            botErrorViewStore.printBotError(handlePrint)
          }
          onCancel={() => botErrorViewStore.cancelBotError()}
          onEdit={
            botErrorViewStore.isEditEnabled
              ? () => botErrorViewStore.editBotError()
              : undefined
          }
          screenshotViewAction={getViewAction(
            (props) => botErrorViewStore.fileDownload(props, "screenshot"),
            (props) => botErrorViewStore.viewFilePdf(props, "screenshot")
          )}
          domSnapshotViewAction={getViewAction(
            (props) => botErrorViewStore.fileDownload(props, "domSnapshot"),
            (props) => botErrorViewStore.viewFilePdf(props, "domSnapshot")
          )}
        />
        <ErrorDialog
          open={botErrorViewStore.errorDialogOpened}
          title={botErrorViewStore.errorTitle}
          description={botErrorViewStore.errorDescription}
          onClose={() => botErrorViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={botErrorViewStore.pdfViewerOpen}
          onClose={() => botErrorViewStore.closePdfViewer()}
          pdfUrl={botErrorViewStore.pdfViewerUrl}
          title={botErrorViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
